module.exports = __webpack_public_path__ + "assets/img/ts-1-light.4a82016a.png";